import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { authActionsPrivate } from '../../store/auth';

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Icon, Search} from '../inspinia'
import Pagination from "react-js-pagination";
import { fi } from 'date-fns/locale';

class Lista extends React.PureComponent
{
    constructor(props)
    {
        super(props);     
        
        this.state = {
            loading: false, filter: "", page: 0,
            list: 
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },

            emailUsuario: this.props.auth.user.email,

            optionsGet : { method: 'GET' , headers: { 'Content-Type': 'application/json' } },
        }

        this.handleCriarNovaLista = this.handleCriarNovaLista.bind(this);
        this.handleBuscarInput    = this.handleBuscarInput.bind(this); 
        this.handleBuscarClick    = this.handleBuscarClick.bind(this); 
        this.handlePageChange     = this.handlePageChange.bind(this);
        this.handleValidacaoLista = this.handleValidacaoLista.bind(this);
    }

    componentDidMount()
    {
        this.LoadListaContato();
    }

    handleCriarNovaLista()
    {
        this.props.history.push(c.CAMPAIGN_ROUTE + "/lista/upload"); 
    }

    handleValidacaoLista()
    {
        this.props.history.push(c.CAMPAIGN_ROUTE + "/lista/validar");
    }

    handleBuscarInput(e)
    {
        this.setState({ ...this.state, filter: e.target.value });   
    }

    handleBuscarClick()
    {
        this.setState({ ...this.state, page: 1 }, this.LoadListaContato(1, this.state.filter));      
    }

    handlePageChange(pageNumber) 
    {
        this.state.page = pageNumber;
        this.LoadListaContato(pageNumber, this.state.filter);
    }

    render()
    {
        return (                     
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Listas de Contatos</h3>
                            </Title>

                            <Content>
                                {/* MENU DE OPÇÕES */}
                                <Row className="m-0 mb-3">
                                    <Column size="4" className="p-1 mx-auto container">

                                        <Button onClick={this.handleCriarNovaLista}><Icon name="fa-plus"/> Criar nova lista</Button>                                   

                                    </Column>

                                    <Column size="4" className="p-1 mx-auto container">

                                        <Button onClick={this.handleValidacaoLista}><Icon name="fa-copy"/>Validar listas</Button> 

                                    </Column>
 
                                    <Column size="4" className="p-0 mx-auto container">

                                        <Search onChange={this.handleBuscarInput} onClick={this.handleBuscarClick} value={this.state.filter} />

                                    </Column>
                                    
                                </Row>

                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <Table data={this.state.list} history={this}/>                                        
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>                     
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">                 
                                    
                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={c.DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>  
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }

    LoadListaContato(pageNumber, filterParam) {
        const self = this;

        const page = Number.isInteger(pageNumber) ? Math.max(0, pageNumber - 1) : 0;
        const limit = 10;
        const telaCampanha = false;

        const raw = filterParam == null ? "" : String(filterParam);
        const filter = raw.trim();

        const base = `${c.API_BASE_URL}/showListContact/${limit}/${page}/${telaCampanha}`;
        const url = filter ? `${base}/${encodeURIComponent(filter)}` : base;

        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, list: response });
        });
    }
}

class Table extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            loading: false,   
            selfMain: props.history,         
            historyMain: props.history.props.history
        }

        this.duplicarClick   = this.duplicarClick.bind(this);
        this.visualizarClick = this.visualizarClick.bind(this);
        this.excluirClick    = this.excluirClick.bind(this);
    }

    duplicarClick(id)
    {
        if (parseInt(id) === 0) return;

        this.LoadDuplicar(id);

        c.TOASTER_INFO("Lista sendo duplicada, o sistema ira informar ao finalizar o processo.");     
        
    }

    visualizarClick(id)
    {
        if (parseInt(id) === 0) return;

        this.state.historyMain.push(c.CAMPAIGN_ROUTE + "/lista/" + id);
    }

    excluirClick(id)
    {
        if (parseInt(id) === 0) return;

        this.LoadExcluir(id);       
       
    }

    atualizaGrid(id)
    {
        if (parseInt(id) === 0) return;

        const results = this.props.data.results;
        results.pop(id);
    }

    statusEnvio(status){
        if (status == "Em Uso"){
            return( <span style={{color:"#EF7800"}}>Em Uso</span>)
        }
        else if (status == "Ativa"){
            return( <span style={{color:"#009966"}}>Ativa</span>)
        }
        else if (status == "Utilizada"){
            return( <span style={{color:"#BBBBBB"}}>Rejeitado</span>)
        }
    }

    LoadExcluir(id)
    {
        let self = this;
        let mainContext = this.state.selfMain;
        
        const url = `${ c.API_BASE_URL }/contact/${ id }`;
        const options =
        {
            method: 'DELETE'
            ,headers: { 'Content-Type': 'application/json' }
            //,body: JSON.stringify(user)
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false});
            self.atualizaGrid(id);
            mainContext.LoadListaContato();
            c.TOASTER_SUCCESS("Lista excluído com sucesso!"); 
        });
    }

    LoadDuplicar(id)
    {
        let self = this;
        let mainContext = this.state.selfMain;
        
        const url = `${ c.API_BASE_URL }/cloneList`;
        const options =
        {
            method: 'POST'
            ,headers: { 'Content-Type': 'application/json' }
            ,body: JSON.stringify({
                id: id
            })
        };
    
        self.setState({...self.state, loading: true})

        callApi(url, options, function(response)
        { 
            self.setState({...self.state, loading: false, list: response});
            c.TOASTER_SUCCESS("Lista duplicado com sucesso!");
            mainContext.state.list.currentPage = 1;
            mainContext.state.page = 1;
            mainContext.LoadListaContato(mainContext.state.list.currentPage);
        });
    }

    render()
    {    
        const data = this.props.data; 
        let html = "";

        if (data.results === undefined)
        {
            html = (<tr><td colSpan="7" scope="row">Carregando...</td></tr>);
        }
        else if (data.results.length === 0)
        {
            html = (<tr><td colSpan="7" scope="row">Nenhum registro encontrado.</td></tr>);
        }
        else if (data.results.length   > 0)
        {
            html = data.results.map(row =>
                <tr key={row.id} id={row.id}>
                    <td>{row.id}</td>
                    <td>{row.data}</td>
                    <td>{row.nome}</td>
                    <td>{row.contatos}</td>
                    <td>{this.statusEnvio(row.status)}</td>
                    <td>{row.nomeCampanha}</td>                                   
                    <td className="text-center">
                        <a onClick={() => this.duplicarClick(row.id)}><Icon name="fa-copy" className="mx-1 text-success"/></a>
                        <a onClick={() => this.visualizarClick(row.id)}><Icon name="fa-search" className="mx-1 text-info"/></a>
                        <a onClick={() => this.excluirClick(row.id)}><Icon name="fa-times" className="mx-1 text-muted"/></a>
                    </td>
                </tr>                  
            );
        }

        return(
            <table className="footable table table-striped toggle-arrow-tiny text-body">
                <thead>
                    <tr style={{backgroundColor: "#dbf1e9"}}>       
                        <th>#</th>
                        <th>Data</th>
                        <th>Nome da lista</th>
                        <th>Contatos</th>
                        <th>Status</th>
                        <th>Vinculado à Campanha</th>
                        <th className="text-center">Ações</th>
                    </tr>
                </thead>

                <tbody>{html}</tbody>
            </table>
        )
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Lista));
